/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#saveCropImg.btn[_ngcontent-%COMP%]{font-size:20px}.actions[_ngcontent-%COMP%]{margin-top:15px}\n/*# sourceMappingURL=superadmindashboard.component.css.map*/"];
export { styles as styles };
